exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-form[data-v-7c499ab9]{width:480px}.el-select[data-v-7c499ab9]{width:100%}", ""]);

// exports
